import React, { useState, useEffect, useRef, useContext } from 'react';
import HeaderDetails from "../../components/header/header_details";
import DataDetails from "../home/data-details/data-details";
import axios from 'axios';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MenuContext } from "../../views/dashboard/admin/admin"; 

function VuelosFacturados() {
    const handleMenuClick = useContext(MenuContext);
    const [collapsed, setCollapsed] = useState(true);
    const [collapsed2, setCollapsed2] = useState(true);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [totales, setTotales] = useState([]);
    const [year, setYear] = useState(true);
    const [week, setWeek] = useState(true);
    const [Estaciones, setEstaciones] = useState(true);
    const [MexDom, setMexDom] = useState(true);
    const [MexExpo, setMexExpo] = useState(true);
    const [Impo, setImpo] = useState(true);
    const [VuelosFacturados, setVuelosFacturados] = useState(true);
    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };
    
    // ESTADOS PARA PAGINACIÓN
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const containerRef = useRef(null);
    const [query, setQuery] = useState(window.location.search);

    // LÓGICA DE SCROLL PARA PAGINACIÓN
    const handleScroll = () => {
        if (containerRef.current) {
            const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
            // Si falta poco para llegar al final, carga la siguiente página
            if (scrollTop + clientHeight >= scrollHeight - 20 && hasMore && !loading) {
                setPage((prevPage) => prevPage + 1);
            }
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }
    }, [hasMore, loading]);

    const toggleCollapse2 = () => {
        setCollapsed2(!collapsed2);
    };

    const getDashboard = async () => {
      try {
        setLoading(true);
        const searchParams = new URLSearchParams(window.location.search);
        const weekParam = searchParams.get('week');
        const yearParam = searchParams.get('year');
        
        if(weekParam && yearParam){
            setYear(yearParam);
            setWeek(weekParam);
            
            const res = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/dashboard/detail_invoice`, {
                params:{
                    'week': weekParam,
                    'year': yearParam,
                    "page": page,
                    "limit": 500
                },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            });

            if (res.data.code === 1){
              // SI ES LA PÁGINA 1, REEMPLAZAMOS. SI ES SCROLL, ACUMULAMOS.
              setData((prevData) => page === 1 ? res.data.results : [...prevData, ...res.data.results]);
              setTotales(res.data.totales_semanas);
              
              // Si recibimos menos de 500, ya no hay más registros
              if(res.data.results.length < 500) setHasMore(false);
              setLoading(false);
            } else {
              setHasMore(false);
              setLoading(false);
            }
        }
      } catch (error) {
        Swal.fire("Error", "Hubo un error", "error");
        setLoading(false);
      }
    };

    // Al cambiar la URL, reiniciamos todo
    useEffect(() => {
        setPage(1);
        setHasMore(true);
        setData([]); 
        getDashboard();
    }, [window.location.search]);

    // Al cambiar la página, cargamos más
    useEffect(() => {
        if(page > 1) getDashboard();
    }, [page]);

    useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth >= 768) {
            setCollapsed(true);
            setCollapsed2(true);
          }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // TU LÓGICA ORIGINAL DE DOM (Corregida para paginación)
    useEffect(() => {
        const tbody = document.getElementById('main-data');
        if (!tbody) return; // Evita el error "Cannot set properties of null"

        // Limpiamos solo si es la carga inicial o si cambió la data totalmente
        tbody.innerHTML = ''; 

        if (data.length > 0) {
            let rowCounter = 1;
            data.forEach((row) => {
                const tr = document.createElement('tr');
                
                const values = [
                    rowCounter, row.folio_fiscal, row.folio_fiscal, row.clave, row.anio, 
                    row.semana, row.tiempo_demora, 'AMC', row.origen, row.destino, 
                    row.guias, row.importe_mx, row.kgsFact, '-'
                ];

                values.forEach(val => {
                    const td = document.createElement('td');
                    td.textContent = val;
                    tr.appendChild(td);
                });

                tbody.appendChild(tr);
                rowCounter++;
            });

            if(totales.length > 0){
                setEstaciones(totales[0].sem_actual_estaciones_este_vuelo);
                setMexDom(totales[0].sem_actual_mex_dom_esta_semana);
                setMexExpo(totales[0].sem_actual_mex_expo_esta_semana);
                setImpo(totales[0].sem_actual_impo_esta_semana);
                setVuelosFacturados(totales[0].vuelos_sem_actual_facturados_esta_semana);
            }
        }
    }, [data, totales]);

    const exportToExcel = () => {
      const mainTable = document.getElementById('main-table');
      const wsMain = XLSX.utils.table_to_sheet(mainTable);
      const secondaryTable = document.getElementById('secondary-table');
      const wsSecondary = XLSX.utils.table_to_sheet(secondaryTable);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, wsMain, 'Vuelos Facturados');
      XLSX.utils.book_append_sheet(wb, wsSecondary, 'Totales');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const buffer = new ArrayBuffer(wbout.length);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < wbout.length; i++) { view[i] = wbout.charCodeAt(i) & 0xff; }
      const fileName = 'vuelos_facturados.xlsx';
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, fileName);
    };

    return (
        <div className="main-section">
            <div className="row mt-4 px-4">
                <div className="col-12 d-flex align-items-end justify-content-center mt-2">
                    <p className=""><b>Vuelos facturados</b></p>
                </div>
                <div className="col-12 d-flex align-items-end justify-content-end mb-3">
                    <span className={`d-flex text-decoration-none justify-content-around blue-pill`} onClick={exportToExcel} style={{cursor:'pointer'}}>
                        <div><p className="fs-11 mt-2 mb-2 me-3 ms-3">Exportar</p></div>
                    </span>
                </div>
                
                <div className="col-12 d-block d-md-none mb-4 c-pointer" onClick={toggleCollapse}>Tabla 1</div>
                <div className={`col-md-2 fs-10 ${collapsed ? '' : 'd-none'}`}>
                    <table className="table table-hover" id="secondary-table">
                        <thead>
                            <tr className="bg-color-gray">
                                <th className="bg-color-gray text-white">Semana</th>
                                <th className="bg-color-gray text-white">Concepto</th>
                                <th className="bg-color-gray text-white">Total</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            <tr className="bg-color-gray">
                                <td rowSpan="5">{ year%10 }{ week }</td>
                               <td>Estaciones</td>
                               <td>{ Estaciones }</td>
                            </tr>
                            <tr className="bg-color-gray"><td>Mex Dom</td><td>{ MexDom }</td></tr>
                            <tr className="bg-color-gray"><td>Mex Expo</td><td>{ MexExpo }</td></tr>
                            <tr className="bg-color-gray"><td>Impo</td><td>{ Impo }</td></tr>
                            <tr className="bg-color-gray"><td>Vuelos Facturados</td><td>{ VuelosFacturados }</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="col-12 d-block d-md-none mb-4 c-pointer" onClick={toggleCollapse2}>Tabla 2</div>
                
                {/* CONTENEDOR CON REF Y SCROLL */}
                <div 
                    className={`col-md-10 fs-10 table-responsive ${collapsed2 ? '' : 'd-none'}`} 
                    ref={containerRef}
                    style={{maxHeight: '75vh', overflowY: 'auto'}}
                >
                    <table className="table table-hover" id="main-table">
                        <thead style={{position: 'sticky', top: 0, background: 'white', zIndex: 1}}>
                            <tr>
                                <th className="bg-color-softblue text-white rounded-table-left">#</th>
                                <th className="bg-color-softblue text-white">Folio Fiscal</th>
                                <th className="bg-color-softblue text-white">Concepto</th>
                                <th className="bg-color-softblue text-white">Clave</th>
                                <th className="bg-color-softblue text-white">Año</th>
                                <th className="bg-color-softblue text-white">Semana</th>
                                <th className="bg-color-softblue text-white">Tiempo Demora</th>
                                <th className="bg-color-softblue text-white">Emisor</th>
                                <th className="bg-color-softblue text-white">Origen</th>
                                <th className="bg-color-softblue text-white">Destino</th>
                                <th className="bg-color-blue text-white">Guías</th>
                                <th className="bg-color-blue text-white">Importe MX</th>
                                <th className="bg-color-blue text-white">Kgs Fac</th>
                                <th className="bg-color-blue text-white rounded-table-right">Tarifa</th>
                            </tr>
                        </thead>
                        <tbody id="main-data"></tbody>
                    </table>
                    {loading && <div className="text-center p-3">Cargando registros...</div>}
                </div> 
            </div>
        </div>
    )
};

export default VuelosFacturados;